/*
  This exists to provide a way for us to clear the Turbolinks cache when a 
  user assumes a new role, resolving issues with flashes of cached pages
  from the previous role.

  Hooks onto elements with .set-assumed-role-btn and uses the data-set-role
  attribute to know which role to set.
*/

// https://github.com/turbolinks/turbolinks/issues/87#issuecomment-218639291
function clearCacheOnce() {
  Turbolinks.clearCache();
  document.removeEventListener("turbolinks:load", clearCacheOnce);
}

document.addEventListener("turbolinks:load", () => {
  // can't use an arrow function here if we want $(this) to work
  $(".set-assumed-role-btn").on("click", function() {
    const role = $(this).attr("data-set-role");
    document.addEventListener("turbolinks:load", clearCacheOnce);
    Turbolinks.visit(
      Routes.set_assumed_role_path({
        // eslint-disable-next-line @typescript-eslint/camelcase
        assumed_role: role,
      })
    );
  });
});



// WEBPACK FOOTER //
// ./app/javascript/libs/set_assumed_role.js